




















import {
  Component,
  Vue
} from "../vuepack";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import { useUserStore } from "@/shared/store/user";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    LoginWrapper,
    GenericLoadingSpinner
  }
})
export default class LostMfaDevice extends Vue {
  userStore = useUserStore();
  portalCustomizationStore = usePortalCustomizationStore();

  get supportTel () {
    return "tel:" + this.portalCustomizationStore.supportInfo.supportPhone;
  }
}
